exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#request-pass .errorApiSec{background:#d25853;color:#fff;padding:5px 10px;font-weight:700;margin-bottom:10px;border-radius:5px;display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/css-loader?minimize!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/autoprefixer-loader?{browsers:["last 3 versions"],cascade:false}!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/stylus-loader??ref--6-3!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/security-payment-details/stylus/_security_custom.styl
// module id = 282
// module chunks = 2